module.exports = __webpack_public_path__ + "media/application/images/svgs/check-83a8cc9e0d0ed46f380dea01b17c0cc2.svg";